import { render, staticRenderFns } from "./_market.vue?vue&type=template&id=10b6681d&scoped=true"
import script from "./_market.vue?vue&type=script&lang=js"
export * from "./_market.vue?vue&type=script&lang=js"
import style0 from "./_market.vue?vue&type=style&index=0&id=10b6681d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b6681d",
  null
  
)

export default component.exports